import * as React from "react";

import { UitkHeading } from "uitk-react-text";

import CardsView from "./components/CardsView";
import ListsView from "./components/ListsView";

import { DestinationCrossLinkProps } from "./typings";
import { ViewType } from "./DestinationCrossLinkEnums";

const DestinationCrossLink = (props: DestinationCrossLinkProps) => {
  const { flexComponent, context } = props;
  const model = flexComponent?.model;
  const destinations = model?.destinations;

  if (!model || model.empty || !destinations || !destinations.length) {
    return null;
  }

  const { title, view, geoType } = model;

  return (
    <div
      className="DestinationCrossLink uitk-cell all-cell-1-1"
      id={props.flexComponent.id}
      data-testid="DestinationCrossLinkHeading"
    >
      <div className="all-b-margin-three">
        <UitkHeading level={2} size={600}>
          {title}
        </UitkHeading>
      </div>

      {view === ViewType.DETAIL ? (
        <CardsView context={context} destinations={destinations} geoType={geoType} />
      ) : (
        <ListsView destinations={destinations} geoType={geoType} />
      )}
    </div>
  );
};

export default DestinationCrossLink;
